import { render, staticRenderFns } from "./detailRow.vue?vue&type=template&id=c86fccca&"
import script from "./detailRow.vue?vue&type=script&lang=ts&"
export * from "./detailRow.vue?vue&type=script&lang=ts&"
import style0 from "./detailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports